(function() {
  const openCartDrawer = () => {
      if (window.Shopify && typeof window.Shopify.openCartDrawer === 'function') {
          window.Shopify.openCartDrawer();
          return;
      }

      const builtInTrigger = document.querySelector('header-actions button[data-testid="cart-drawer-trigger"], button[data-testid="cart-drawer-trigger"], #custom-cart-drawer-trigger, .cart-drawer-trigger');
      if (builtInTrigger) {
          builtInTrigger.click();
          return;
      }

      const drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function') {
          drawer.open();
          return;
      }

      window.dispatchEvent(new CustomEvent('cart:open'));
  };

  const dispatchCartUpdate = (cartData) => {
      document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          composed: true,
          detail: {
              resource: cartData,
              data: {
                  itemCount: cartData?.item_count,
                  source: 'custom-product-add-to-cart',
              },
          },
      }));
  };

  const initProductPage = () => {
    // 1. Accordion Logic (Original)
    document.querySelectorAll('.accordion-header').forEach(button => {
        button.addEventListener('click', () => {
            const content = button.nextElementSibling;
            button.classList.toggle('active');
            content.style.maxHeight = button.classList.contains('active') ? content.scrollHeight + "px" : "0px";
            button.querySelector('.plus-icon').textContent = button.classList.contains('active') ? '-' : '+';
        });
    });

    // 2. Variant Logic (Original)
    const variantInputs = document.querySelectorAll('.variant-input');
    const variantFormSection = document.querySelector('.product-variants');
    const sectionId = variantFormSection?.dataset.section;
    const productJsonElement = sectionId ? document.getElementById(`ProductJson-${sectionId}`) : null;
    const productJson = productJsonElement ? JSON.parse(productJsonElement.textContent || '{}') : null;
    const variantIdInput = document.querySelector(`input[name="id"]#variant-id-${sectionId}`) || document.querySelector('input[name="id"]');
    const priceWrapper = sectionId ? document.getElementById(`price-${sectionId}`) : document.querySelector('.product-price-wrapper');

    variantInputs.forEach(input => {
        input.addEventListener('change', () => {
            if (!productJson) return;
            const selectedOptions = Array.from(document.querySelectorAll('.variant-input:checked')).map(checked => checked.value);
            const variant = productJson.variants.find(v => v.options.every(opt => selectedOptions.includes(opt)));
            if (variant) {
                if (variantIdInput) variantIdInput.value = variant.id;
                if (priceWrapper) {
                    const currentPriceEl = priceWrapper.querySelector('.current-price');
                    if (currentPriceEl) {
                        const formattedPrice = typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function'
                            ? Shopify.formatMoney(variant.price)
                            : variant.price;
                        currentPriceEl.innerText = formattedPrice;
                    }
                }
            }
        });
    });

    // 3. New Qnt Selector Logic
    const qtyInput = document.querySelector('.qty-input-field');
    if(qtyInput) {
        document.querySelector('.qty-control.plus').addEventListener('click', () => qtyInput.value = parseInt(qtyInput.value) + 1);
        document.querySelector('.qty-control.minus').addEventListener('click', () => {
            if(parseInt(qtyInput.value) > 1) qtyInput.value = parseInt(qtyInput.value) - 1;
        });
    }

    const productForm = document.querySelector('form[action*="/cart/add"]');
    if (productForm) {
        productForm.addEventListener('submit', async (event) => {
            event.preventDefault();
            const formData = new FormData(productForm);
            const payload = {};

            formData.forEach((value, key) => {
                payload[key] = key === 'quantity' ? Number(value) : value;
            });

            try {
                const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    body: JSON.stringify(payload)
                });

                const data = await response.json();
                if (!response.ok) throw data;

                let cartData = data;
                try {
                    const cartResponse = await fetch('/cart.js');
                    if (cartResponse.ok) {
                        cartData = await cartResponse.json();
                    }
                } catch (cartError) {
                    console.warn('Unable to fetch updated cart state', cartError);
                }

                dispatchCartUpdate(cartData);
                openCartDrawer();
            } catch (error) {
                console.error('Add to cart failed', error);
            }
        });
    }

    const stickyButton = document.querySelector('.sticky-add-to-cart');
    const addToCartButton = document.querySelector('.as_add-to-cart-btn, .add-to-cart-btn');
    if (stickyButton && addToCartButton) {
        stickyButton.addEventListener('click', () => addToCartButton.click());
    }

    // 4. New Buy Now Logic
    const buyNowBtn = document.querySelector('.buy-now-btn-custom');
    if(buyNowBtn && productForm) {
        buyNowBtn.addEventListener('click', async () => {
            const variantId = productForm.querySelector('input[name="id"]')?.value;
            const qty = productForm.querySelector('input[name="quantity"]')?.value || 1;

            if (!variantId) {
                console.warn('Buy now: variant id not found');
                return;
            }

            try {
                const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    body: JSON.stringify({
                        id: variantId,
                        quantity: Number(qty)
                    })
                });

                const data = await response.json();
                if (!response.ok) throw data;

                let cartData = data;
                try {
                    const cartResponse = await fetch('/cart.js');
                    if (cartResponse.ok) {
                        cartData = await cartResponse.json();
                    }
                } catch (cartError) {
                    console.warn('Unable to fetch updated cart state', cartError);
                }

                dispatchCartUpdate(cartData);
                openCartDrawer();
            } catch (error) {
                console.error('Buy now failed', error);
            }
        });
    }

    // 5. Mobile Slider & Sticky Button Logic
    if(window.innerWidth <= 768) {
        const slider = document.querySelector('.slider-mobile');
        const stickyBar = document.getElementById('MobileStickyBar');
        const gallery = document.querySelector('.product-gallery-side');

        if (slider && stickyBar && gallery) {
            window.addEventListener('scroll', () => {
                const galleryBottom = gallery.offsetTop + gallery.offsetHeight;
                if (window.scrollY > galleryBottom) stickyBar.classList.add('show');
                else stickyBar.classList.remove('show');
            });

            const items = slider.querySelectorAll('.product-gallery-item');
            const dotsBox = document.querySelector('.slider-pagination-dots');
            if (dotsBox) {
                items.forEach((_, i) => {
                    const dot = document.createElement('div');
                    dot.className = i === 0 ? 'dot active' : 'dot';
                    dotsBox.appendChild(dot);
                });
            }

            slider.addEventListener('scroll', () => {
                const index = Math.round(slider.scrollLeft / slider.offsetWidth);
                document.querySelectorAll('.dot').forEach((d, i) => d.classList.toggle('active', i === index));
            });
        }
    }
};

document.addEventListener('DOMContentLoaded', initProductPage);
document.addEventListener('shopify:section:load', initProductPage);

document.addEventListener("DOMContentLoaded", () => {
  const checkboxes = document.querySelectorAll(".bundle-checkbox-input");
  const totalPriceEl = document.getElementById("bundle-total-price");
  const addBundleBtn = document.querySelector(".bundle-add-all-btn");

  if (!checkboxes.length || !totalPriceEl) {
    return;
  }

  function updateBundlePrice() {
    let total = 0;

    checkboxes.forEach((checkbox) => {
      if (checkbox.checked) {
        total += Number(checkbox.dataset.price || 0);
      }
    });

    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      totalPriceEl.innerHTML = Shopify.formatMoney(total);
    } else {
      totalPriceEl.textContent = total;
    }
  }

  checkboxes.forEach((checkbox) => {
    checkbox.addEventListener("change", updateBundlePrice);
  });

  if (!addBundleBtn) {
    return;
  }

  addBundleBtn.addEventListener("click", async () => {
    const items = [];

    checkboxes.forEach((checkbox) => {
      if (checkbox.checked) {
        items.push({
          id: checkbox.dataset.variantId,
          quantity: 1
        });
      }
    });

    if (items.length === 0) {
      alert("Please select at least one product");
      return;
    }

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items })
      });

      const data = await response.json();
      if (!response.ok) throw data;

      let cartData = data;
      try {
        const cartResponse = await fetch('/cart.js');
        if (cartResponse.ok) {
          cartData = await cartResponse.json();
        }
      } catch (cartError) {
        console.warn('Unable to fetch updated cart state', cartError);
      }

      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        composed: true,
        detail: {
          resource: cartData,
          data: {
            itemCount: cartData.item_count ?? data.item_count,
            source: 'bundle-add-all'
          }
        }
      }));
      openCartDrawer();
    } catch (error) {
      console.error('Error adding bundle items:', error);
    }
  });
});

})();